import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  outputDataKey: {
    defaultMessage: 'Output data key',
    id: `app.containers.WorkflowEditor.components.Rules.Action.MultiplyApplicantValue.outputDataKey`,
    description: 'Label for the data key the multiply action writes to',
  },
  sourceDataKey: {
    defaultMessage: 'Source data key',
    id: `app.containers.WorkflowEditor.components.Rules.Action.MultiplyApplicantValue.sourceDataKey`,
    description: 'Label for the data key the multiply action reads from',
  },
  multiplyBy: {
    defaultMessage: 'Multiply by',
    id: `app.containers.WorkflowEditor.components.Rules.Action.MultiplyApplicantValue.multiplyBy`,
    description: 'Label for the numeric factor the multiply action applies',
  },
});
